import React from 'react';

const TESTIMONIALS = [
  {
    photo:    '/josephlaughter.jpg',
    initial:  'JL',
    business: 'Joseph Laughter Clothier',
    quote:    "Since the Lightning's inception, we've generated an unmeasurable volume of high-quality, loyal customers. Local advertising here is easy and profitable.",
    adType:   '1/4 Page Print Ad',
  },
  {
    photo:    '/trolleyco3.png',
    initial:  'TC',
    business: 'The Trolley Company',
    quote:    "For several years we have run a monthly ad exclusively in The Lightning to advertise our Trolley Baseball Tours. Local print advertising works and our increased ticket sales every year proves that locals are reading local.",
    adType:   '1/8 Page Print Ad',
  },
];

export default function Testimonials() {
  return (
    <div className="testimonials-section">
      <div className="testimonials-heading">What local businesses are saying</div>
      <div className="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <div key={i} className="testimonial-card">
            <div className="testimonial-top">
              <div className="testimonial-avatar">
                {t.photo
                  ? <img src={t.photo} alt={t.business} className="testimonial-photo" />
                  : t.initial}
              </div>
              <div>
                <div className="testimonial-business">{t.business}</div>
                <div className="testimonial-ad-badge">{t.adType}</div>
              </div>
            </div>
            <p className="testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
          </div>
        ))}
      </div>
    </div>
  );
}
